import { createContext } from 'react';

export const ItemCardContext = createContext<{
  isLoaded: boolean;
}>({
  isLoaded: false,
});
